import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

interface Props {
  onBulkIgnore: () => void;
  onBulkReset: () => void;
  className?: string;
}

export default function BulkObjectActionDropdown(props: Props): JSX.Element {
  return (
    <Dropdown
      className="u-mini-spacing-right u-flex-grow"
      menu={
        <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.MEDIUM}>
          <Option onSelect={props.onBulkIgnore}>Ignore all</Option>
          <Option onSelect={props.onBulkReset}>Reset all</Option>
        </Menu>
      }
    >
      <Button
        className={classNames(css(styles.actionMenuToggle), props.className)}
        buttonStyle={ButtonStyle.TERTIARY_BLUE}
        text="Action"
        isDropdown={true}
        size={ButtonSize.SMALL}
      />
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  actionMenuToggle: {
    cursor: 'pointer',
  },
});
